import React from 'react';
import { Helmet } from 'react-helmet-async';
import './CommunityGuidelines.css';

function CommunityGuidelines() {
  return (
    <div className="guidelines-container">
      <Helmet>
        <title>Community Guidelines | QuantumKE</title>
        <meta name="description" content="QuantumKE's community guidelines for respectful collaboration and knowledge sharing. Read the rules that keep our quantum community inclusive and innovative." />
        <link rel="canonical" href="https://quantumke.org/guidelines" />
      </Helmet>
      <div className="guidelines-header">
        <h1 className="guidelines-title">Welcome to Quantumke</h1>
        <p className="guidelines-subtitle">We're glad to have you with our community</p>
      </div>
      
      <div className="guidelines-card">
        <div className="guidelines-section">
          <div className="rules-section">
            <h2 className="guide-section-title">Community Guidelines</h2>
            <p className="mission-text">
              Our Mission is to bridge the quantum gap by driving innovation, empowering talent, and supporting startups across Kenya and beyond.
            </p>
            <div className="guideline-box">
              <h3 className="guideline-title">Guideline 1: Use your good judgment in all situations</h3>
              <p className="guideline-text">
                There will be no additional guidelines. We trust our community members to act with integrity and respect.
              </p>
            </div>
          </div>
          
          <div className="disclaimer-box">
            <h3 className="disclaimer-title">Disclaimer</h3>
            <p className="disclaimer-text">
              This community does not support or tolerate any form of discrimination, harassment, hate speech, illegal activities, or content that violates the rights of others. Quantumke reserves the right to remove any member who acts contrary to the spirit of our community values.
            </p>
          </div>
        </div>
      </div>

      <div className="guidelines-footer">
           <p>Have questions or need assistance? Contact our team at <a href="mailto:info@quantumke.org">info@quantumke.org</a>. We're here to help support your quantum journey.</p>
      </div>
    </div>
  );
}

export default CommunityGuidelines;